import { render, staticRenderFns } from "./Headerbar.vue?vue&type=template&id=61aae710"
import script from "./Headerbar.vue?vue&type=script&lang=js"
export * from "./Headerbar.vue?vue&type=script&lang=js"
import style0 from "./Headerbar.vue?vue&type=style&index=0&id=61aae710&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports